var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCarrossel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#203264;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.5,0A29.5,29.5,0,1,0,59,29.5,29.5,29.5,0,0,0,29.5,0ZM44.76,30.68h0L31.09,44.36a1.68,1.68,0,0,1-2.38,0h0L27.14,42.8a1.69,1.69,0,0,1,0-2.39l0,0,8.48-8.08H15.44a1.68,1.68,0,0,1-1.69-1.67h0V28.38a1.69,1.69,0,0,1,1.68-1.69H35.65l-8.48-8.07a1.68,1.68,0,0,1-.07-2.37l0-.05,1.56-1.56a1.69,1.69,0,0,1,2.38,0h0L44.76,28.3A1.69,1.69,0,0,1,44.76,30.68Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCarrossel);
export default __webpack_public_path__ + "static/media/arrow-carrossel.7c143744a612a44a2d5f69bb33c2d024.svg";
export { ForwardRef as ReactComponent };